import { MeditationSVG } from "./SVGIllustrations";
import { PillSelect } from "@/components/we360/PillSelect";
import { CalculatedBadge } from "@/components/we360/CalculatedBadge";
import { ANXIETY_ITEMS, ANXIETY_OPTIONS, classifyAnxiety } from "./helpers";

export default function Step1Anxiety({ answers, onChange, allAnswered, score, errors }) {
  const cls = allAnswered ? classifyAnxiety(score) : null;

  return (
    <div>
      <MeditationSVG />

      <div
        className="rounded-[14px] p-4 mt-3 mb-4 text-xs leading-relaxed"
        style={{ background: "#F3E5F0", border: "1px solid rgba(136,52,118,0.15)", color: "#2D2A24" }}
        data-testid="f5-intro-text"
      >
        Las siguientes preguntas se refieren a cómo te has sentido en las <strong>últimas 2 semanas</strong>. No hay respuestas buenas ni malas — solo queremos entender cómo estás.
      </div>

      {ANXIETY_ITEMS.map((item, i) => (
        <div key={item.id} className="mb-4">
          <span className="text-xs font-semibold block mb-1" style={{ color: "#2D2A24" }}>
            {item.label}
          </span>
          <PillSelect
            options={ANXIETY_OPTIONS}
            value={answers[i] ?? ""}
            onChange={(v) => onChange(i, v)}
            error={errors?.getError(`anx_${i}`)}
            testId={`f5-anx-${item.id}`}
            columns={1}
          />
        </div>
      ))}

      {allAnswered && cls && (
        <CalculatedBadge
          label="Ansiedad (GAD-5)"
          value={`${score}/15`}
          category={cls.label}
          categoryColor={cls.color}
          testId="badge-ansiedad"
        />
      )}
    </div>
  );
}
